export default __webpack_public_path__ + "locales/ja-JP/RoomLogoCover.json?hash=944f576f1bc6119bb1621273bd9552dc";